// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-button-group {
  gap: 8px;
}

/*# sourceMappingURL=ButtonGroup.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/ButtonGroup/ButtonGroup.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/ButtonGroup/ButtonGroup.css"],"names":[],"mappings":"AACA;EACI,QCmTQ;ACnTZ;;AAEA,0CAA0C","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
